export enum TargetType {
    SUCCESS = 'success',
    FAILURE = 'failure'
}

export interface TargetSession {
    enabled: boolean
    month: number;
    sessionTarget?: number;
}

export interface ContentTypeData {
    idContentType: number;
    contentTypeName: string;
    exceptionMonths: Array<TargetSession>;
}
export interface BrandData {
    idBrand: number;
    brandName: string;
    iconImage: string;
    exceptionDisableClass: string;
    collapseDisableClass:string;
    enabledMonths: Array<number>;
    months: Array<TargetSession>;
    contentTypeList: Array<ContentTypeData>
}



// WEBPACK FOOTER //
// ./js/utils/types/article_target.ts